/*
    Please note: this file is also used by the animod-shop-ssr project
 */

/**
 * @typedef {Object} MarketingIconInfo
 * @property {number} id
 * @property {string} text
 * @property {string} value
 * @property {string} imgSrc
 * @property {boolean} deprecated
 */

/**
 * @exports {MarketingIconInfo[]} icons
 */
export default [
    {id: 0, text: '<Ohne>', value: '', imgSrc: '', deprecated: false},
    // {id: 1, text: 'Clock', value: 'last_order', imgSrc: 'assets/images/icons/clock.png', deprecated: false},
    // {id: 2, text: 'Person', value: 'person', imgSrc: 'assets/images/icons/person.png', deprecated: false}
    {id: 1, text: 'Wecker', value: 'alarm', imgSrc: 'assets/images/icons/alarm.png', deprecated: false},
    {id: 2, text: 'Herz', value: 'heart', imgSrc: 'assets/images/icons/heart.png', deprecated: false},
    {id: 3, text: 'Stern', value: 'star-full', imgSrc: 'assets/images/icons/star-full.png', deprecated: false},
    {id: 4, text: 'Personen', value: 'users', imgSrc: 'assets/images/icons/users.png', deprecated: false},
    {id: 5, text: 'Megafon', value: 'bullhorn', imgSrc: 'assets/images/icons/bullhorn.png', deprecated: false},
    {id: 6, text: 'Kalender', value: 'calendar', imgSrc: 'assets/images/icons/calendar.png', deprecated: false},
    {id: 7, text: 'Feuer', value: 'fire', imgSrc: 'assets/images/icons/fire.png', deprecated: false},
    {id: 8, text: 'Blitz', value: 'power', imgSrc: 'assets/images/icons/power.png', deprecated: false},
    {id: 9, text: 'Flugzeug', value: 'airplane', imgSrc: 'assets/images/icons/airplane.png', deprecated: false},
    {id: 10, text: 'Einkaufswagen', value: 'cart', imgSrc: 'assets/images/icons/cart.png', deprecated: false},
    {id: 11, text: 'Rabattmarke', value: 'price-tags', imgSrc: 'assets/images/icons/price-tags.png', deprecated: false},
    {id: 12, text: 'Info i', value: 'info', imgSrc: 'assets/images/icons/info.png', deprecated: false},
    {id: 13, text: 'Warnung', value: 'warning', imgSrc: 'assets/images/icons/warning.png', deprecated: false},
    {id: 14, text: 'Ausrufezeichen', value: 'notification', imgSrc: 'assets/images/icons/notification.png', deprecated: false},
    {id: 15, text: 'Fragezeichen', value: 'question', imgSrc: 'assets/images/icons/question.png', deprecated: false},
    {id: 16, text: 'Pin', value: 'pushpin', imgSrc: 'assets/images/icons/pushpin.png', deprecated: false}
];
